"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.macedoniaTranslations = void 0;
var _types = require("../../../types");
const macedoniaTranslations = exports.macedoniaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Се извинуваме!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Назад',
  [_types.ErrorPageTranslationKey.text]: 'Во моментов, страницата не може да се отвори',
  [_types.ErrorPageTranslationKey.notFound]: 'Страницата што се обидувате да ја пронајдете не работи',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Страницата до која се обидувате да стигнете е ограничена и не се исполнети сите критериуми.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Ве молиме контактирајте го тимот за поддршка на Орифлеим преку е-пошта:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Бараната URL-адреса беше одбиена!'
};
